export default {
    init() {
        setupBlocks();
    }
}
function setupBlocks() {
    let $blocks = $('.block-hero').not('.initialised');

    if ($blocks.length > 0) {
        $blocks.each((index, item) => {
            let $block = $(item);

            setupBlock($block);

            $block.addClass('initialised');
        });
    }
}

function setupBlock($block) {
    setupDropdown($block)
}

function setupDropdown($block) {
    let $dropdownWrapper = $block.find('.dropdown-options-inner');
    let $dropdownBtn     = $block.find('.dropdown-btn');

    $dropdownBtn.on('click', function(){
        if (!$dropdownWrapper.hasClass('open')){
            $dropdownWrapper.addClass('open');
        } else {
            $dropdownWrapper.removeClass('open');
        }
    });

    $dropdownWrapper.on('focusout', function(){
        if ($dropdownWrapper.hasClass('open')) {
            $dropdownWrapper.removeClass('open');
        }
    });
}